import { HireFieldsStep } from "./HireFieldsStep";

export function HirePersonalStep() {
  return <HireFieldsStep group="personal" />;
}
